(function () {
  function getFetchConfig() {
    if (typeof fetchConfig === 'function') {
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      return config;
    }

    return {
      method: 'POST',
      headers: {
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest',
      },
    };
  }

  function openCartDrawer(cartData) {
    const cart = document.querySelector('cart-drawer');

    if (!cart) {
      window.location.href = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
      return;
    }

    if (typeof cart.renderContents === 'function') {
      cart.renderContents(cartData);
    }

    cart.classList.remove('is-empty');
    cart.classList.add('active');
    document.body.classList.add('overflow-hidden');
  }

  async function handleAddToCart(form) {
    const button = form.querySelector('.fpv2-btn');
    const spinner = form.querySelector('.loading-overlay__spinner');
    const errorBox = form.querySelector('[data-fpv2-error]');
    const formData = new FormData(form);

    if (!button) return;

    button.classList.add('loading');
    button.disabled = true;

    if (spinner) spinner.classList.remove('hidden');

    if (errorBox) {
      errorBox.style.display = 'none';
      errorBox.textContent = '';
    }

    try {
      const cart = document.querySelector('cart-drawer');
      const config = getFetchConfig();

      if (cart && typeof cart.getSectionsToRender === 'function') {
        formData.append(
          'sections',
          cart.getSectionsToRender().map(function (section) {
            return section.id;
          })
        );

        formData.append('sections_url', window.location.pathname);

        if (typeof cart.setActiveElement === 'function') {
          cart.setActiveElement(document.activeElement);
        }
      }

      config.body = formData;

      const addUrl = window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add';
      const response = await fetch(addUrl, config);
      const data = await response.json();

      if (data.status) {
        throw data;
      }

      openCartDrawer(data);
    } catch (error) {
      if (errorBox) {
        errorBox.textContent =
          error && (error.description || error.message)
            ? error.description || error.message
            : 'An error occurred';
        errorBox.style.display = 'block';
      }
    } finally {
      button.classList.remove('loading');
      button.disabled = false;
      if (spinner) spinner.classList.add('hidden');
    }
  }

  function initCard(card) {
    if (card.dataset.fpv2Initialized === 'true') return;
    card.dataset.fpv2Initialized = 'true';

    const variantsScript = card.querySelector('[data-fpv2-variants]');
    let variants = [];

    if (variantsScript) {
      try {
        variants = JSON.parse(variantsScript.textContent);
      } catch (e) {
        variants = [];
      }
    }

    card.querySelectorAll('[data-fpv2-swatch]').forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        const variantId = Number(swatch.dataset.variantId);
        const variant = variants.find(function (item) {
          return Number(item.id) === variantId;
        });

        if (!variant) return;

        const input = card.querySelector('input[name="id"]');
        const titleLink = card.querySelector('.fpv2-title');
        const imageLink = card.querySelector('.fpv2-image-link');
        const mainImage = card.querySelector('.fpv2-image--main');
        const hoverImage = card.querySelector('.fpv2-image--hover');
        const button = card.querySelector('.fpv2-btn');
        const buttonText = card.querySelector('.fpv2-btn-text');

        if (input) input.value = variant.id;

        card.querySelectorAll('[data-fpv2-price]').forEach(function (priceItem) {
          priceItem.classList.toggle(
            'hidden',
            Number(priceItem.dataset.variantId) !== Number(variant.id)
          );
        });

        if (titleLink) titleLink.href = variant.url;
        if (imageLink) imageLink.href = variant.url;

        if (variant.image && mainImage) {
          mainImage.src = variant.image;
          mainImage.srcset = '';
        }

        if (variant.image && hoverImage) {
          hoverImage.src = variant.image;
          hoverImage.srcset = '';
        }

        if (button) button.disabled = !variant.available;

        if (buttonText) {
          buttonText.textContent = variant.available ? 'Add to Bag' : 'Sold out';
        }

        card.querySelectorAll('[data-fpv2-swatch]').forEach(function (item) {
          item.classList.remove('is-active');
        });

        swatch.classList.add('is-active');
      });
    });

    card.querySelectorAll('[data-fpv2-form]').forEach(function (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        handleAddToCart(form);
      });
    });
  }

  function initProductGridV2(scope) {
    const container = scope || document;
    container.querySelectorAll('[data-fpv2-card]').forEach(initCard);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initProductGridV2(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initProductGridV2(event.target);
  });

  window.initProductGridV2 = initProductGridV2;
})();